var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"outlined":"","dense":"","items":_vm.items,"value":_vm.items[0],"item-text":"text","item-value":"value","label":_vm.$t('message.select_interval')},on:{"input":event => { _vm.emitChange(event) }},model:{value:(_vm.selectedItem),callback:function ($$v) {_vm.selectedItem=$$v},expression:"selectedItem"}})
}
var staticRenderFns = []

export { render, staticRenderFns }